angular.module('app.directives.schedule').directive('scoreboardConfigSummary', () => {
  return {
    restrict: 'E',
    scope: {
      service: '=',
      scoreboardConfiguration: '=',
      labelSuffix: '@',
      boldLabels: '=',
      boldValues: '=',
    },
    controller: function ($scope) {
      'ngInject';
      $scope.labelStyle = { 'font-weight': $scope.boldLabels ? 'bold' : 'normal' };
      $scope.valueStyle = { 'font-weight': $scope.boldValues ? 'bold' : 'normal' };
    },
    template: `
      <p ng-style="labelStyle">Sport{{labelSuffix}}<br>
        <em ng-if="!scoreboardConfiguration.sport">No Sport Selected</em>
        <span ng-style="valueStyle" ng-if="scoreboardConfiguration.sport">{{service.sports | getById:scoreboardConfiguration.sport:'value':'label'}}</strong>
      </p>
      <div ng-if="scoreboardConfiguration.sport">
        <p ng-style="labelStyle">Scoreboard{{labelSuffix}}<br>
          <em ng-if="scoreboardConfiguration.manual === undefined">No Scoreboard</em>
          <span ng-style="valueStyle" ng-if="scoreboardConfiguration.manual === true">Manual</span>
          <span ng-style="valueStyle" ng-if="scoreboardConfiguration.manual === false && scoreboardConfiguration.connection === 'scoreboard_assist'">Scoreboard Assist</span>
          <span ng-style="valueStyle" ng-if="scoreboardConfiguration.manual === false && scoreboardConfiguration.connection === 'scorebot'">Sportzcast ScoreBot {{sc.sportzcast_bot_number}}</span>
          <span ng-style="valueStyle" ng-if="scoreboardConfiguration.manual === false && scoreboardConfiguration.connection === 'scoreboard_adapter'">
            {{service.scoreboards | getById:scoreboardConfiguration.scoreboard_make:'value':'label'}} /
            {{service.scoreboardModels | getById:scoreboardConfiguration.scoreboard_model:'value':'label'}}
          </span>
        </p>
        <p ng-style="labelStyle">Team{{labelSuffix}}<br>
          <button type="button" class="btn btn-default btn-sm btn-color-picker" uib-dropdown-toggle
            style="text-shadow: rgb(0, 0, 0) 0px 0px 3px; color: rgb(255, 255, 255);"
            ng-style="{'background-color': scoreboardConfiguration.home_team_logo}">
            <span style="white-space:pre;font-family:monospace;">{{scoreboardConfiguration.home_team_name | scoreboardTeamName}}</span>
          </button>
          vs.
          <button type="button" class="btn btn-default btn-sm btn-color-picker" uib-dropdown-toggle
            style="text-shadow: rgb(0, 0, 0) 0px 0px 3px; color: rgb(255, 255, 255);"
            ng-style="{'background-color': scoreboardConfiguration.away_team_logo}">
            <span style="white-space:pre;font-family:monospace;">{{scoreboardConfiguration.away_team_name | scoreboardTeamName}}</span>
          </button>
        </p>
        <p ng-style="labelStyle">Video Overlay{{labelSuffix}}<br>
          <span ng-style="valueStyle" style="text-transform:capitalize">{{scoreboardConfiguration.overlay_location}}</span>
        </p>
        </p>
      </div>
      `,
  };
});



// WEBPACK FOOTER //
// ./app/directives/schedule/scoreboard-config-summary.js